import { EventEmitter } from '@angular/core';
var ComponentTip = (function () {
    function ComponentTip() {
        this.sureText = "确定";
        this.cancelText = "取消";
        this.desText = "";
        this.type = "tip";
        this.returnType = 0;
        this.tipType = "";
        this.onSure = new EventEmitter();
        this.onCancel = new EventEmitter();
        this.onAnother = new EventEmitter();
    }
    ComponentTip.prototype.ngOnInit = function () {
        console.log(this.returnType);
    };
    ComponentTip.prototype.sure = function () {
        if (this.returnType === 0) {
            this.onSure.emit();
        }
        else {
            this.onAnother.emit(true);
        }
    };
    ComponentTip.prototype.cancel = function () {
        this.onCancel.emit();
    };
    return ComponentTip;
}());
export { ComponentTip };



// WEBPACK FOOTER //
// ./src/component/tip/component.tip.ts.pre-build-optimizer.js